import React from "react";
import css from "./CoachMark.module.scss";
import { coachmark_pin, pointer } from "../../Images/Icons";
import { NavLink } from "react-router-dom";
const CoachMarkStep8 = (props) => {
    return (
        <div style={{ position: "relative" }}>
            <div className={css.backdrop}>
                <div className={css.higlight8}>
                    <div className={css.point}>
                        <img src={coachmark_pin}/>
                    </div>
                </div>
                <div className={css.content}>                
                    <i class="fi fi-rr-cross-small"></i>
                    <div className={css.title}>💡 Take control of your energy consumption!</div>
                    <div className={css.desc}>In this section, you can view detailed data on your energy usage, including daily, monthly, yearly, and lifetime consumption. </div>
                    <div className={css.step}>8/10</div>
                    <NavLink to="/home" onClick={props.prev}>
                        <button className={css.prev}>Previous</button>
                    </NavLink>
                    <NavLink to="/home" onClick={props.next}>
                        <button className={css.next}>Next</button>
                    </NavLink>
                    
                </div>
            </div>
        </div>
    );
};

export default CoachMarkStep8;
